import { Doctor } from '../../types';

// Mock doctors database
export let mockDoctors: Doctor[] = [
  {
    id: '1',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '2',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '3',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '4',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '5',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '6',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '7',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '8',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '9',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '10',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
  {
    id: '11',
    name: 'NGUYỄN THANH VŨ',
    licenseNumber: '000756HCM-CCHN',
    phone: '0969789789',
    email: 'bsntvu@gmail.com',
    nationalPrescriptionUser: 'bsvutmh150ph',
  },
];

